import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    label: 'Velocidad mental',
    sin: 'Se deteriora 1% por año sin intervención',
    costo: 'Reflejos ejecutivos entrenados y medibles'
  }, {
    label: 'Memoria',
    sin: 'Olvidos que se acumulan sin sistema',
    costo: 'Técnicas instaladas que funcionan en la vida real'
  }, {
    label: 'Decisiones',
    sin: 'Más lentas, más costosas, más dudosas',
    costo: 'Arquitectura lógica activa ante cualquier situación'
  }, {
    label: 'Foco',
    sin: 'Fragmentado por el entorno digital',
    costo: 'Atención sostenida recuperada y protegida'
  }, {
    label: 'Autoridad',
    sin: 'Se erosiona cuando la mente empieza a fallar',
    costo: 'Se sostiene porque la mente sigue siendo tu mejor herramienta'
  }];
  return <section className="py-10 px-4 pt-[15px] pb-[15px] flex-row items-center justify-center" data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <div className="text-center mb-6" data-id="element-113">
          <h2 className="text-2xl md:text-3xl font-black mb-2" data-id="element-114">
            🎙️ ¿Cuánto cuesta NO entrenarlo?
          </h2>
          <p className="text-gray-400" data-id="element-115">
            O podés tener todo resuelto desde hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-116">
          {costs.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border p-4 rounded-xl" data-id="element-117">
              <div className="text-white font-bold text-xs uppercase tracking-wider mb-2" data-id="element-118">
                {item.label}
              </div>
              <div className="text-gray-400 text-xs mb-1" data-id="element-119">
                <span className="text-red-400 font-bold" data-id="element-120">Sin Protocolo:</span>{' '}
                {item.sin}
              </div>
              <div className="text-brand font-bold text-sm" data-id="element-121">
                Con Protocolo: {item.costo}
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-2xl mx-auto mt-8 text-gray-300 text-sm leading-relaxed space-y-3" data-id="element-122">
          <p data-id="element-123">
            Hacé la cuenta. Si tu velocidad de procesamiento baja un 10% y tomás
            20 decisiones importantes por semana, ¿cuántas de esas decisiones
            son peores de lo que podrían ser? ¿Cuánto vale cada una de esas
            decisiones en tu negocio, en tu familia, en tu vida?
          </p>
          <p data-id="element-124">
            Si perdés 2 horas por día de foco productivo por la fragmentación
            digital, son 10 horas por semana, 40 horas por mes, casi 500 horas
            por año. Tiempo que podrías estar usando para lo que realmente
            importa.
          </p>
          <p data-id="element-125">
            Si tu autoridad en el entorno se erosiona porque empezás a dudar, a
            olvidar, a responder más lento, ¿cuánto vale recuperarla?
          </p>
          <p className="text-brand font-bold text-base" data-id="element-126">
            El Protocolo Mente Indomable no es un gasto. Es la inversión más
            inteligente que un hombre de tu edad puede hacer en sí mismo.
          </p>
        </div>
      </div>
    </section>;
}